import React from "react";

import clsx from "clsx";
import { rem, transparentize } from "polished";
import styled, { css } from "styled-components";

import { useMountTransition } from "../../hooks/use-mount-transition";
import Portal from "../../hooks/use-portal";

const Modal = ({
  wrapperId = "modal",
  isOpen,
  children,
  title,
  handleClose,
  hasOverlay = true,
  overlayClick = false,
  showClose = true,
  parentStyles,
  stickyHeader = false,
  removeWhenClosed = true,
  className,
  styles,
  locked = true,
}) => {
  const isTransitioning = useMountTransition({
    isMounted: isOpen,
    unmountDelay: 300,
  });

  if (!isTransitioning && removeWhenClosed && !isOpen) {
    return null;
  }

  return (
    <Portal wrapperId={wrapperId} locked={locked}>
      <ModalWrapper
        className={clsx("modal", className, {
          open: isOpen,
          in: isTransitioning,
        })}
        style={parentStyles}
      >
        {hasOverlay ? (
          <div
            className="backdrop"
            onClick={overlayClick ? handleClose : () => {}}
          />
        ) : null}
        <div
          className={clsx("modal-box", {
            stickyHeader,
          })}
          style={styles}
        >
          {title ? (
            <div className="header">
              <h6>{title}</h6>
              {showClose ? (
                <div className="close" onClick={handleClose}>
                  {/* <IconClose size={14} /> */}X
                </div>
              ) : null}
            </div>
          ) : null}
          <div className="modal-container">{children}</div>
        </div>
      </ModalWrapper>
    </Portal>
  );
};
export default Modal;

const ModalWrapper = styled.div`
  ${({ theme }) => css`
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.3s ease all;
    &.open {
      transition: 0.3s;

      &.in {
        transition: 0.3s;

        .backdrop {
          visibility: visible;
          opacity: 1;
          pointer-events: auto;
          z-index: 1;
        }

        .modal-box {
          transition: 0.3s;

          transform: scale(1);
          opacity: 1;
          visibility: visible;
        }
      }
    }

    .header h6,
    .header .close {
      font-size: 28px;
      margin: 0;
    }

    .backdrop {
      visibility: hidden;
      opacity: 0;
      background-color: ${transparentize(0.5, theme.colors.white)};
      transition: opacity 0.3s ease, visibility 0.3s ease;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      position: fixed;
      pointer-events: none;
      z-index: 0;
    }

    .modal-box {
      position: relative;
      z-index: 2;
      max-width: 300px;
      width: 100%;
      overflow: hidden;
      -webkit-user-select: text;
      -webkit-border-radius: 8px;
      border-radius: 8px;
      box-shadow: 0 3px 6px ${transparentize(0.84, theme.colors.black)};
      padding: 0 ${rem(20)} ${rem(20)};
      background-color: ${theme.colors.white};
      transform: scale(0.8);
      opacity: 0;
      visibility: hidden;
      transition: visibility 0.3s ease, opacity 0.3s ease, transform 0.3s ease;
      display: flex;
      flex-direction: column;

      &.stickyHeader {
        padding-top: 0;

        .header {
          position: sticky;
          top: 0px;
          background-color: ${theme.colors.white};
          z-index: 1;
          padding: ${rem(20)} 0;
        }
      }

      .header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: ${rem(15)};
        background: ${theme.colors.primary};
        text-align: center;
        padding: 15px 20px;
        margin: 0 -20px;
        color: ${theme.colors.white};
        margin-bottom: 0;
        font-size: 34px;
        line-height: 40px;

        h6 {
          line-height: normal;
        }

        .close {
          cursor: pointer;
        }
      }

      .input-field {
        /* margin-bottom: ${rem(30)}; */
      }

      .button {
        margin: 0 auto;
      }
    }

    .modal-container {
      flex-grow: 1;
      height: 100%;
      overflow: hidden auto;
      margin: 0 -20px;
      padding: 0 20px;
      border: none;
    }

    &.center-block {
      .modal-container {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  `}
`;
